module.exports = __webpack_public_path__ + "02_long_black.e37943e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_long_black.png
// module id = hwhA
// module chunks = 0